import { useTheme } from "../../../contexts/ThemeContext";

const USE_CASES = [
  {
    icon: "ri-trophy-line",
    category: "Sports Cards",
    title: "Stop Underpricing Your Flips",
    description:
      "PSA slabs, raw cards, vintage singles — Trackly calculates real profit on every card you sell across eBay, PWCC, StockX, and more. Know your ROI before you list, not after.",
    stat: "Most card flippers miss 18–22% in fees",
  },
  {
    icon: "ri-shoe-line",
    category: "Sneakers & Streetwear",
    title: "StockX & GOAT Fees Add Up Fast",
    description:
      "StockX, GOAT, and Flight Club all have complex fee tiers that vary by seller level and sale price. Trackly pre-loads every fee structure so you know your net on any shoe in seconds.",
    stat: "StockX alone: 9–10% + payment fees",
  },
  {
    icon: "ri-shirt-line",
    category: "Clothing & Apparel",
    title: "Poshmark & Depop Cut Deep",
    description:
      "Poshmark takes 20% on sales over $15, Depop takes 10% plus payment processing. Vintage and branded clothing resellers lose serious margin without realizing it. Trackly shows you the real number every time.",
    stat: "Poshmark sellers: 20% gone on every sale",
  },
  {
    icon: "ri-seedling-line",
    category: "Beginners",
    title: "Learn Your Numbers From Day One",
    description:
      "New to reselling? Trackly teaches you exactly what fees to expect on every platform before you list — whether you&apos;re starting with cards, shoes, or clothes. Build good habits early and never wonder where your money went.",
    stat: "No experience needed to use Trackly",
  },
];

export default function DemoUseCases() {
  const { isDark } = useTheme();

  return (
    <section className={`py-24 px-8 lg:px-16 border-t transition-colors duration-300 ${isDark ? "bg-[#080808] border-white/5" : "bg-[#f5f5f5] border-black/5"}`}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className={`font-inter text-xs uppercase tracking-[0.2em] block mb-4 ${isDark ? "text-[#666666]" : "text-[#888888]"}`}>
            Who It&apos;s For
          </span>
          <h2 className={`font-syne font-bold text-5xl ${isDark ? "text-white" : "text-[#111111]"}`}>
            Built for every kind <br />
            <span className={isDark ? "text-[#444444]" : "text-[#cccccc]"}>of reseller.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {USE_CASES.map((uc) => (
            <div
              key={uc.title}
              className={`border rounded-2xl p-8 transition-colors duration-300 cursor-default ${
                isDark
                  ? "bg-[#0d0d0d] border-white/5 hover:border-white/10"
                  : "bg-white border-black/5 hover:border-black/10"
              }`}
            >
              <div className="flex items-start gap-4 mb-5">
                <div className={`w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0 ${isDark ? "bg-white/5" : "bg-black/5"}`}>
                  <i className={`${uc.icon} text-lg ${isDark ? "text-[#666666]" : "text-[#777777]"}`} />
                </div>
                <div>
                  <span className={`font-inter text-xs uppercase tracking-widest ${isDark ? "text-[#555555]" : "text-[#999999]"}`}>{uc.category}</span>
                  <h3
                    className={`font-syne font-semibold text-xl mt-0.5 ${isDark ? "text-white" : "text-[#111111]"}`}
                    dangerouslySetInnerHTML={{ __html: uc.title }}
                  />
                </div>
              </div>
              <p
                className={`font-inter text-sm leading-relaxed mb-5 ${isDark ? "text-[#555555]" : "text-[#666666]"}`}
                dangerouslySetInnerHTML={{ __html: uc.description }}
              />
              <div className={`flex items-center gap-2 border rounded-full px-4 py-2 w-fit ${isDark ? "bg-white/3 border-white/5" : "bg-black/3 border-black/5"}`}>
                <i className={`ri-information-line text-xs ${isDark ? "text-[#666666]" : "text-[#888888]"}`} />
                <span className={`font-inter text-xs ${isDark ? "text-[#666666]" : "text-[#888888]"}`}>{uc.stat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
